import VueRouter from 'vue-router'
import homeRoutes from './home';
import multaRoutes from './multa';

const routes = [
    ...homeRoutes, ...multaRoutes, 
]

const router = new VueRouter({
    routes,
    mode: 'history',
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
  });

export default router